export default __webpack_public_path__ + "locales/ko-KR/PeopleTranslations.json?hash=fc8afc249398641aab09383565088432";